const textOutlineColor = 'white';
export const fontColor = 'black';
export const nodeBGColor = '#4f5b66';
export const edgeBGColor = '#c0c5ce';
export const nodeMinSize = 10;
export const fontMaxSize = 20;
export const fontMinSize = 12;
export const dimColor = '#f4f4f8';
export const dimOpacity = 0.3;
export const edgeWidth = '0.6px';
export const arrowScale = 0.5
export const arrowActiveScale = 0.5
export const successorColor = 'rgb(246, 176, 172)';
export const predecessorsColor = 'rgb(140, 232, 250)';
export const nodeActiveBGColor = '#fed766';
export const nodeActiveSize = 23;
export const nodeActiveFontSize = 7;
export const edgeActiveWidth = '1px';
export const groupCandidateSelectedColor = '#43a047';
export const stylesheet = [ // the stylesheet for the graph
    {
        selector: 'node',
        style: {
            'font-family': 'Open Sans Condensed',
            'font-weight': '200',
            'label': 'data(label)',
            'text-valign': 'top',
            'color': fontColor,
            'text-outline-width': 0,
            'text-outline-color': textOutlineColor,
            'background-color': nodeBGColor
        }
    },
    {
        selector: 'edge',
        style: {
            'curve-style': 'bezier',
            'width': 1,
            'target-arrow-shape': 'triangle',
            'line-color': edgeBGColor,
            'target-arrow-color': edgeBGColor,
        }
    },
    {
        // [node-parent-or] 새 그룹을 만들 때 "포함할 지식"으로 고른 후보 노드를 표시하는 스타일.
        // SelectGroupMembers.js가 선택/해제할 때마다 addClass/removeClass('group-candidate-selected')한다.
        selector: '.group-candidate-selected',
        style: {
            'border-width': 3,
            'border-style': 'solid',
            'border-color': groupCandidateSelectedColor
        }
    },
    {
        // [#127] Node.parent가 있는 노드들(OR 대안 그룹)을 감싸는 compound 부모 노드 스타일.
        // ':parent'는 cytoscape가 자식을 가진 노드에 자동으로 붙이는 셀렉터이며,
        // 위의 일반 'node' 셀렉터 스타일 위에 겹쳐 적용되어 기존 노드/엣지 스타일은 그대로 유지된다.
        // [#135] 반투명 배경(background-color/opacity)이 엣지 색상과 구분하기 어려워 제거하고,
        // 점선 테두리(border)만으로 그룹 경계를 표시한다.
        selector: ':parent',
        style: {
            'background-opacity': 0,
            'border-width': 1,
            'border-style': 'dashed',
            'border-color': nodeBGColor,
            'shape': 'round-rectangle',
            'padding': '12px',
            'text-valign': 'top',
            'text-halign': 'center',
            'font-size': fontMinSize
        }
    }
]; // const successorWeakColor = '#ff8b94';
